export const LOADING_TASK = "LOADING_TASK";
export const GET_TASK_LIST = "GET_TASK_LIST";
export const REMOVE_TASK = "REMOVE_TASK";
export const ADD_TASK = "ADD_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const GET_TASK_BY_ID = "GET_TASK_BY_ID";
export const GET_TASK_BY_LEADID = "GET_TASK_BY_LEADID";